<template>
    <section class="analysis-results main-section">
        <header class="analysis-patient-banner">
            <div class="analysis-patient-banner__title">
                    <h1>
                        <a href="javascript:;" class="text-primary" @click="$router.go(-1)">
                            Salle de prélèvement
                        </a> | <span> {{ modele_analyse.analyse.nom }} | </span> Saisie résultats
                    </h1>
            </div>
            <div class="analysis-patient-banner__identity">
                <div class="analysis-patient-banner__patient"><small>Patient</small><strong>{{ patientMeta.patient_fullname || 'Non renseigné' }}</strong><span>{{ patientMeta.patient_reference || 'Sans référence' }}</span></div>
                <div><small>Sexe / âge</small><strong>{{ formatSexeCourt(patientMeta.patient_gender) }}<template v-if="patientMeta.patient_age"> · {{ patientMeta.patient_age }}</template></strong></div>
                <div><small>Téléphone</small><strong>{{ patientMeta.patient_phone || '—' }}</strong></div>
                <div><small>Médecin demandeur</small><strong>{{ patientMeta.doctor_fullname || 'Non renseigné' }}</strong></div>
                <div class="analysis-patient-banner__wide"><small>Renseignement clinique / indication</small><strong>{{ patientMeta.clinical_inquiries || 'Non renseigné' }}</strong></div>
                <div><small>Technique</small><strong>{{ patientMeta.methodology_applied || 'Non renseignée' }}</strong></div>
            </div>
        </header>
        <div v-if="patientMeta.laboratory_return_reason" class="alert alert-warning" role="note"><strong>Motif du retour</strong><p>{{ patientMeta.laboratory_return_reason }}</p></div>

        <div class="card analysis-results-body brder-radius-x">
            <div class="card-body">
                <div class="row my-2 mt-2">
                    <div class="col-12 pdlr-x">
                        <div class="card h-100 animate animate-fadeIn">
                            <div class="card-body">
                                <ResultatsAnalysesFormTable 
                                    @emitSetResult="printResultSaved"
                                />
                            </div>                
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row mb-4">
            <div class="col-lg-12">
                <div class="body-header">
                    <h1 class="p-title">
                        <a href="javascript:;" class="text-primary" @click="$router.go(-1)">
                            Salle de prélèvement
                        </a> | <span> {{ modele_analyse.analyse.nom }} | </span> Saisie résultats
                    </h1>
                </div>
            </div>
        </div> -->

        <!-- <div class="row mb-2">
            <div class="col-lg-12">
                <CollapseCard>
                    <template v-slot:header>Entête du tableau des résultats</template>
                    <template v-slot:body>
                        <table class="patient-details w-100 table table-bordered mb-2">
                            <tbody>
                                <tr v-for="(row, index) in head_meta_rows" :key="index">
                                    <td :colspan="row && row.colspan" :class="'text-' + (row && row.align)">
                                        <strong>{{ row && row.title }}</strong>
                                        <span class="">{{ row && row.value }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </CollapseCard>
            </div>
        </div> -->

        

        <!-- Print  -->
        <div 
            class="card w-100 print-anl" 
            slot="pdf-content" 
            v-if="can_print"
        >
            <div class="card-body pdlr-x">
                <EnteteBonEtFacture />
                <ResultatPatient
                    :results="results"
                    :view_result_loading="view_result_loading"
                />
            </div>
        </div>
    </section>
</template>

<script>

// import CollapseCard from '@/components/cards/CollapseCard.vue';
import ResultatsAnalysesFormTable from './components/ResultatsAnalysesFormTable.vue';
import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

export default {
    name: 'SaisieResultats',
    components: {
        EnteteBonEtFacture,
        ResultatsAnalysesFormTable, ResultatPatient
    },
    data() {
        return {
            view_result_loading: false,
            results: null,
            can_print: false,
            head_info: {}
        }
    },
    computed: {
        patientMeta() {
            return this.$store.getters["patientMetaData"];
        },

        head_meta_rows() {
            const rows = [
                {
                    title: "Nom & prénom(s) : ",
                    value: this.patientMeta.patient_fullname != null ? this.patientMeta.patient_fullname : '-',
                    colspan: 2,
                    align: 'left',
                },
                {
                    title: "Sexe : ",
                    value: this.formatSexeCourt(this.patientMeta.patient_gender),
                },
                {
                    title: "Age : ",
                    value: this.patientMeta.patient_age != null ? this.patientMeta.patient_age : '-',
                    align: 'left',
                },
                {
                    title: "Médecin demandeur : ",
                    value: this.patientMeta.doctor_fullname != null ? this.patientMeta.doctor_fullname : '-',
                    colspan: 2,
                    align: 'left',
                },
                {
                    title: "Renseignement clinique : ",
                    value: this.patientMeta.clinical_inquiries != null ? this.patientMeta.clinical_inquiries : '-',
                    colspan: 2,
                },
                {
                    title: "Technique utilisée : ",
                    value: this.patientMeta.methodology_applied != null ? this.patientMeta.methodology_applied : '-',
                    colspan: 2,
                }
            ];

            return rows;
        },

        modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },
    },

    watch: {
        
    },

    mounted() {
    },

    methods: {
        printResultSaved(results) {
            console.log("saved results :",results);
            
            this.results = results
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
        }
    },
}
</script>

<style src="./styles/resultats-analyse.scss" lang="scss" scoped></style>
<style scoped lang="scss">
.analysis-results{min-height:100vh;background:#edf4ff;padding:24px 32px 56px;color:var(--ui-text, #293957)}
.analysis-patient-banner{position:relative;z-index:2;background:#fff;border:1px solid #c9d9f7;border-radius:18px;overflow:hidden;box-shadow:0 8px 26px rgba(38,54,83,.06);margin-bottom:18px}
.analysis-patient-banner__title{padding:18px 22px;border-bottom:1px solid #dce6f7;background:#f5f8fd}.analysis-patient-banner__title h1{font-size:22px;margin:0;color:var(--ui-text, #293957)}
.analysis-patient-banner__identity{display:grid;grid-template-columns:minmax(220px,1.3fr) repeat(3,minmax(140px,.8fr));gap:1px;background:#dce6f7}.analysis-patient-banner__identity>div{background:#fff;padding:14px 18px;min-width:0}.analysis-patient-banner__identity small,.analysis-patient-banner__identity strong,.analysis-patient-banner__identity span{display:block}.analysis-patient-banner__identity small{color:var(--ui-text-secondary, #718099);margin-bottom:4px}.analysis-patient-banner__identity strong{white-space:normal;overflow-wrap:anywhere}.analysis-patient-banner__identity span{color:var(--ui-text-secondary, #718099);font-size:12px;margin-top:3px}.analysis-patient-banner__wide{grid-column:span 2}
.analysis-results-body{position:relative;inset:auto;height:auto;overflow:visible;border:1px solid #c9d9f7}
@media(max-width:1100px){.analysis-results{padding:18px}.analysis-patient-banner__identity{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:680px){.analysis-patient-banner__identity{grid-template-columns:1fr}.analysis-patient-banner__wide{grid-column:auto}}
</style>
